import React from "react";
import { FormattedDate } from "react-intl";
import PropTypes from "prop-types";
import { DateTime as dt } from "luxon";
import { updateTimeZoneOffset } from "core/shared/util/TimeZoneUtils";

export const isDateValid = (date) => {
  return date instanceof Date
    ? !Number.isNaN(date) && date.toString() !== "Invalid Date"
    : date.isValid;
};
export default function DateTime({
  formatOptions,
  formatter,
  timeZone,
  removeTimeZone,
  showTime,
  value,
}) {
  const isoDate = value instanceof Date ? value.toISOString() : value;
  let date;
  if (removeTimeZone) {
    date = new Date(updateTimeZoneOffset(isoDate));
  } else if (timeZone) {
    date = dt.fromISO(isoDate, { zone: timeZone });
  } else {
    date = dt.fromISO(isoDate);
  }

  if (!isDateValid(date)) return "--";

  const dateFormatOptions = formatOptions
    ? {
        value: date,
        ...(removeTimeZone ? {} : { timeZone }),
        ...formatOptions,
      }
    : {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        ...(showTime && {
          hour: "2-digit",
          minute: "2-digit",
        }),
        value: date,
        ...(removeTimeZone ? {} : { timeZone }),
      };

  return formatter ? (
    formatter(date, { ...dateFormatOptions })
  ) : (
    <FormattedDate {...dateFormatOptions} />
  );
}

DateTime.propTypes = {
  formatOptions: PropTypes.shape({}),
  formatter: PropTypes.func,
  timeZone: PropTypes.string,
  removeTimeZone: PropTypes.bool,
  showTime: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
